<template>


  <section class="mt-5 sm-max:px-6">



    <h2 class="text-42 sm-max:mb-4 sm-max:px-4 md-max:pt-8 text-center pt-12 max-w-xl m-auto leading-head pb-4 sm-max:text-21 md-only:text-32">

      <div>

        <div>
         <span class="font-bold" v-html="titleBold">

         </span>

          <em class="italic font-medium" style="font-family: sans-serif;">{{ titleItalic }}</em>
          <span class="font-bold">...
          </span>
        </div>
      </div>
    </h2>




    <div class="grid grid-cols-4 sm-max:grid-cols-2">


      <nuxt-img
          v-for="image in images"
          :key="image.alt"
          class="cols-span-1 w-full"
          loading="lazy"
          width="300"
          height="435"
          format="webp"
          :alt="image.alt"
          :src="image.src"
      />

    </div>

  </section>

</template>



<script setup>

const props = defineProps({
  titleBold: {
    type: String,
    default: 'People All Over the USA </br> Are '
  },
  titleItalic: {
    type: String,
    default: 'Loving This Coffee',
  },
  images: {
    type: Array,
    default: () => [
      { src: "/person-1.jpg", alt: "person-1" },
      { src: "/person-2.jpg", alt: "person-2" },
      { src: "/person-3.jpg", alt: "person-3" },
      { src: "/person-4.jpg", alt: "person-4" },
      { src: "/person-5.jpg", alt: "person-5" },
      { src: "/person-6.jpg", alt: "person-6" },
      { src: "/person-7.jpg", alt: "person-7" },
      { src: "/person-8.jpg", alt: "person-8" },
      { src: "/person-9.jpg", alt: "person-9" },
      { src: "/person-10.jpg", alt: "person-10" },
      { src: "/person-11.jpg", alt: "person-11" },
      { src: "/person-12.jpg", alt: "person-12" },
      { src: "/person-13.jpg", alt: "person-13" },
      { src: "/person-14.jpg", alt: "person-14" },
      { src: "/person-15.jpg", alt: "person-15" },
      { src: "/person-16.jpg", alt: "person-16" },

    ],
  },
})


defineBuilderComponent({
    friendlyName: 'AllPeople',
    canHaveChildren: true,
    inputs: [
      {
        name: 'titleBold',
        type: 'text',
        defaultValue: 'People All Over the USA Are ',
      },
      {
        name: 'titleItalic',
        type: 'text',
        defaultValue: 'Loving This Coffee',
      },
      {
        name: 'images',
        type: 'list',
        subFields: [
          {
            name: 'src',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            required: true,
          },
          {
            name: 'alt',
            type: 'text',
            required: true,
          },
        ],
        defaultValue: [
          { src: "/person-1.jpg", alt: "person-1" },
          { src: "/person-2.jpg", alt: "person-2" },
          { src: "/person-3.jpg", alt: "person-3" },
          { src: "/person-4.jpg", alt: "person-4" },
          { src: "/person-5.jpg", alt: "person-5" },
          { src: "/person-6.jpg", alt: "person-6" },
          { src: "/person-7.jpg", alt: "person-7" },
          { src: "/person-8.jpg", alt: "person-8" },
          { src: "/person-9.jpg", alt: "person-9" },
          { src: "/person-10.jpg", alt: "person-10" },
          { src: "/person-11.jpg", alt: "person-11" },
          { src: "/person-12.jpg", alt: "person-12" },
          { src: "/person-13.jpg", alt: "person-13" },
          { src: "/person-14.jpg", alt: "person-14" },
          { src: "/person-15.jpg", alt: "person-15" },
          { src: "/person-16.jpg", alt: "person-16" },
        ],
      },
    ],
  })
</script>